import React, { Component } from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'
import { compose, bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { fetchPortalListings } from '../../../modules/portal-remote/portalService'
import withLanguage from '../lang-select/withLanguage'
import { addListingPortal } from '../../../actions/listing'
import InputText from '../../views/widgets/InputText'
import styled from 'styled-components'

class ListingPortalSearch extends Component {
  static propTypes = {}

  constructor(props) {
    super(props)
    this.loadPortals = _.debounce(this.loadPortals, 500)
  }

  state = {
    searchText: '',
    portals: [],
  }

  componentDidMount() {
    //load portal from old server
    this.loadPortals()
  }

  loadPortals = async () => {
    const queries = {
      [`title.${this.props.language}`]: this.state.searchText,
      town: _.get(this.props, 'town._id'),
      limit: 50,
      jsonLevel: 10,
    }
    const portals = await fetchPortalListings(queries)
    this.setState({ portals })
  }

  handleSearchChange = e => {
    const searchText = e.target.value
    this.setState({ searchText }, this.loadPortals)
  }

  handlePortalSelect = portal => {
    this.props.actions.addListingPortal(portal)
  }

  render() {
    const portals = _.reject(this.state.portals, portal => {
      return _.includes(this.props.listingPortalIds, portal._id)
    })
    return (
      <div>
        <div className="heading">
          <p className="panel-heading">Search Portals</p>
          <div className="panel-block">
            <div className="control has-icons-left">
              <InputText
                type="text"
                onChange={this.handleSearchChange}
                value={this.state.searchText}
                placeholder="search..."
              />
              <span className="icon is-small is-left">
                <i className="fas fa-search" aria-hidden="true" />
              </span>
            </div>
          </div>
        </div>
        <PanelStyle>
          {/* <p className="panel-tabs">
          <a className="is-active">all</a>
          <a>public</a>
          <a>private</a>
          <a>sources</a>
          <a>forks</a>
        </p> */}
          <table className="table is-fullwidth is-hoverable">
            <tbody>
              {_.map(portals, portal => (
                <tr key={portal._id}>
                  <td> {_.get(portal, 'title.th')}</td>
                  <td className="has-text-right">
                    <button
                      className="button is-success is-small"
                      onClick={() => this.handlePortalSelect(portal)}
                    >
                      Add
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </PanelStyle>
      </div>
    )
  }
}

const PanelStyle = styled.nav.attrs({ className: 'panel' })`
  height: 60vh;
  overflow-y: auto;
}
`

export default compose(
  withLanguage,
  connect(
    ({ town, listing }) => ({
      town,
      listingPortalIds: _.map(listing.portals, 'ref'),
    }),
    dispatch => ({
      actions: bindActionCreators(
        { addListingPortal: addListingPortal },
        dispatch,
      ),
    }),
  ),
)(ListingPortalSearch)



// WEBPACK FOOTER //
// ./src/components/templates/listing-portal/ListingPortalSearch.js